import {Toast, ToastType} from '@sportcast/ui-react';
import {formatISO} from 'date-fns';
import React, {useEffect, useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';
import './Message.scss';

export enum MessageId {
    UNREAD_INCIDENTS,
    SEVERE_INCIDENT_NOTIFICATION
}

export type MessageProps = {
    id?: string,
    message?: string | React.ReactElement,
    messageId?: MessageId,
    autoClose?: boolean,
    type: ToastType,
    autoCloseDuration?: number,
    i18nMessage?: string
};

const Message = (props: MessageProps) => {
    const [t] = useTranslation();
    const [showMessage, setShowMessage] = useState(true);

    useEffect(() => {
        setShowMessage(true);
    }, [props.id]);

    const handleClose = () => {
        if (props.messageId === MessageId.UNREAD_INCIDENTS) {
            // Make sure notification about unread incidents stays hidden until new incidents appear
            window.sessionStorage.setItem('acknowledgedIncidentsNotification', formatISO(Date.now()));
        }

        setShowMessage(false);
    };

    const delay = useMemo(() => {
        if (props.autoCloseDuration) {
            return props.autoCloseDuration;
        }
        return props.type === ToastType.ERROR ? 10000 : 3000;
    }, [props.autoCloseDuration, props.type]);

    return (
        <div className="message">
            <Toast
                id={props.id}
                message={props.i18nMessage ? <><p>{t(props.i18nMessage)}</p> <p
                    className="font-weight-light">{props.message}</p></> : props.message}
                show={showMessage}
                variant={props.type}
                onClose={handleClose}
                autohide={props.autoClose === true || props.type !== ToastType.DEFAULT}
                delay={delay}
            />
        </div>
    );
};

export default Message;
